var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8e92bc",
    width: "800px",
    height: "800px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5860 42.7422 L 25.9844 53.1953 C 27.3438 53.9687 28.6094 53.9922 30.0157 53.1953 L 48.4141 42.7422 C 50.5938 41.5000 51.7890 40.2344 51.7890 36.8359 L 51.7890 18.2734 C 51.7890 15.6719 50.7580 14.1953 48.8360 13.0937 L 32.2657 3.6719 C 29.3829 2.0078 26.5704 2.0312 23.7344 3.6719 L 7.1641 13.0937 C 5.2422 14.1953 4.2110 15.6719 4.2110 18.2734 L 4.2110 36.8359 C 4.2110 40.2344 5.4063 41.5000 7.5860 42.7422 Z M 28.0000 26.0312 L 10.1407 15.9297 L 25.3985 7.2109 C 27.1797 6.2031 28.7735 6.1797 30.6016 7.2109 L 45.8595 15.9297 Z M 9.7891 39.4609 C 8.4532 38.7109 8.0079 37.9843 8.0079 36.7187 L 8.0079 19.2343 L 26.0313 29.5234 L 26.0313 48.6953 Z M 46.2110 39.4609 L 29.9688 48.6953 L 29.9688 29.5234 L 47.9922 19.2343 L 47.9922 36.7187 C 47.9922 37.9843 47.5468 38.7109 46.2110 39.4609 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockMenu);
export default __webpack_public_path__ + "static/media/stock_menu.8ab62e4a8b39b902bc4fe3d066cd663d.svg";
export { ForwardRef as ReactComponent };